// React
import React, { Component } from "react";
import { Helmet } from 'react-helmet';

// Stores
import { UserProfileStore, SocketStore } from '../../Stores';

// Panels
import { Overview, Holdings, Positions, Orders, TradeHistory, DailyPnl, CurrencyHistory, NewCurrencyHistory, HistoricalPnl } from './';

// Components

class Dashboard extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            socket : null
        };
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Dashboard.componentDidMount()');

        var user = UserProfileStore.getUser();

        // If user logged in, refresh pnl
        if(user !== null) {
            UserProfileStore.getPnl(false);
            UserProfileStore.getHistPnl(false, 30);
        }

        if(this.state.socket === null) {
            this.setupSocketConnection();
        }
    
    }


    // When dashboard is unmounting, end connection
    componentWillUnmount() {
        
        //console.log('Dashboard.componentWillUnmount()');

        // Turn off the socket
        this.state.socket.off();

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Set initial socket connection for the dashboard
    setupSocketConnection() {
    
        //console.log('Dashboard.setupSocketConnection()');
    
        var socket = SocketStore.getSocket();
    
        this.setState((prev, props) => {
            return {
                socket: socket
            }
        });
    
      }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Dashboard.render()');

    var userProfile = UserProfileStore.getUser();

    return (

        <div className="page-container">

            <Helmet>
                <meta charSet="utf-8" />
                <title>Yety | Dashboard - Cryptocurrency Trading and Analytics Platform - The Most Advanced Cryptocurrency Analytics Ever Made</title>
                <link rel="canonical" href="https://yety.io/dashboard" />
                <meta name="keywords" content="cryptocurrency, trading, analytics, pnl, profit, loss, holdings, assets, margin, positions, orders, kraken, poloniex, BTC, ETH, LTC, XRP, DASH, BCH EUR, USD, CAD"/>
                <meta name="description" content="Yety Dashboard has the most advanced cryptocurrency analytics ever made.  With detailed breakdowns of your holdings across four major exchanges, you can see profit and loss in terms of USD and BTC for the first time.  Follow your margin positions with real-time updates and see historical trends in your trading habits." />

                <meta property="og:url" content="https://yety.io/dashboard" />
                <meta property="og:title" content="Yety | Dashboard - Cryptocurrency Trading and Analytics Platform" />
                <meta property="fb:app_id" content="378120756002310" />
                <meta property="twitter:title" content="Yety | Dashboard - Cryptocurrency Trading and Analytics Platform" />
            </Helmet>

          <div className="page-content">

            <div className="content-wrapper">

              {/*-----------  Page header -----------*/}

              {/*-----------  Content Area -----------*/}
              <div className="content">

                {/*-----------  Top Row  -----------*/}
                <div className="row row-sortable ui-sortable">
                    
                    {/*-----------  Present Column -----------*/}
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">

                        <Overview user={userProfile} />

                        <Holdings user={userProfile} />

                    </div>
                    {/*-----------  /Present Column -----------*/}

                    {/*-----------  Future Column -----------*/}
                    <div className="col-lg-5 col-md-6 col-sm-6 col-xs-12">
                    
                        <Positions user={userProfile} socket={this.state.socket}/>

                        <Orders user={userProfile} />

                        <TradeHistory user={userProfile} />
                        
                    </div>
                    {/*-----------  /Future Column -----------*/}


                    {/*-----------  Past Column -----------*/}
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    
                        <HistoricalPnl user={userProfile} />

                        <DailyPnl user={userProfile} />

                        <NewCurrencyHistory user={userProfile} />

                    </div>
                    {/*-----------  /Past Column -----------*/}


                </div>
                {/*-----------  /Grid -----------*/}

              </div>
              {/*-----------  /Content Area -----------*/}


            </div>

          </div>
        </div>
    );
  }
}

export default Dashboard;





// WEBPACK FOOTER //
// ./src/Views/Dashboard/Dashboard.js